import queryString from 'qs';
import moment from 'moment';

export const getScheduleRequest = (filters) => {
  const { dateRange } = filters;

  const queries = {
    startedAt: moment(dateRange?.startDate).toISOString(),
    endedAt: moment(dateRange?.endDate).add(1, 'day').toISOString(),
  };

  // Add filter
  if (filters?.account) queries['accountLivestreams.id'] = `[${filters.account?.map(({ value }) => value)}]`;
  if (filters?.brand) queries['accountLivestreams.brands.name'] = filters.brand?.value;
  if (filters?.host) queries['hosts.name'] = filters.host?.label;
  if (filters?.operator) queries['operators.name'] = filters.operator?.label;
  if (filters?.platform) queries['accountLivestreams.ecommerce.id'] = filters.platform?.value;
  if (filters?.studio) queries['studio.name'] = filters.studio?.label;
  if (filters?.area) queries['studio.area.name'] = filters.area?.label;

  return queryString.stringify(queries, { skipEmptyString: true });
};

export default getScheduleRequest;
